<template>
  <div class="upselling">
    <div class="upselling-custom shadow-box" v-if="custom">
      <slot></slot>

      <button class="add-to-basket" :disabled="isLoading" @click="addToBasket(variationId)"><i class="fa fa-cart-plus"></i></button>
    </div>
    <div v-else>
      <div class="upselling-items" v-if="upsellingItems.length">
        <p class="mb-2">
          <b>Passend dazu</b>
        </p>
        <div class="upselling-swiper">
          <div class="swiper" ref="upselling-swiper">
            <div class="swiper-wrapper" role="list">
              <div v-for="(upsellingItem, index) in upsellingItems" :key="index + '-upselling'" class="swiper-slide" role="listitem">
                <div class="upselling-item">
                  <div class="upselling-item-left">
                    <a v-if="upsellingItem.data.images.variation[0]" :href="upsellingItem.data | itemURL" class="item-name">
                      <lazy-img
                          v-if="upsellingItem.data.images.variation[0].urlMiddle"
                          :image-url="upsellingItem.data.images.variation[0].urlMiddle"
                          :alt="upsellingItem.data | itemName"
                          height="65"
                          width="65"
                      ></lazy-img>
                    </a>
                    <div class="upselling-item-left-content">
                      <a :href="upsellingItem.data | itemURL" class="item-name">{{ upsellingItem.data | itemName }}</a>
                    </div>
                  </div>

                  <div class="upselling-item-right">
                    <div class="item-total-price">{{ upsellingItem.data.prices.default.price.formatted }}</div>
                    <button class="add-to-basket mt-auto" :disabled="isLoading" @click="addToBasket(upsellingItem.data.variation.id)">
                      <i class="fa fa-cart-plus"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="swiper-button-next" ref="upselling-swiper-next">
            <i class="fa fa-chevron-right"></i>
          </div>
          <div class="swiper-button-prev" ref="upselling-swiper-prev">
            <i class="fa fa-chevron-left"></i>
          </div>
        </div>

        <div class="swiper-pagination" ref="upselling-swiper-pagination"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper'
import { Autoplay, Navigation, Pagination } from 'swiper/modules'
import ExceptionMap from '../exceptions/ExceptionMap'

export default {
  name: 'app-upselling',

  props: {
    isPreview: {
      type: Boolean,
    },
    custom: {
      type: Boolean,
    },
    variationId: {
      type: Number,
    },
  },

  mounted() {
    this.$nextTick(() => {
      const swiperEl = this.$refs['upselling-swiper']
      const swiperPaginationEl = this.$refs['upselling-swiper-pagination']
      const swiperButtonNextEl = this.$refs['upselling-swiper-next']
      const swiperButtonPrevEl = this.$refs['upselling-swiper-prev']
      if (swiperEl) {
        new Swiper(swiperEl, {
          modules: [Navigation, Pagination, Autoplay],
          slidesPerView: 1.1,
          spaceBetween: 6,
          breakpoints: {
            998: {
              slidesPerView: this.isPreview ? 1.1 : 2.16,
              spaceBetween: this.isPreview ? 6 : 12,
            },
          },
          lazy: {
            loadPrevNext: true,
          },
          pagination: {
            el: swiperPaginationEl,
            clickable: true,
          },
          navigation: {
            nextEl: swiperButtonNextEl,
            prevEl: swiperButtonPrevEl,
            clickable: true,
          },
        })
      }
    })
  },

  computed: {
    upsellingItems() {
      const quickselectStorage = JSON.parse(localStorage.getItem('basket_quickselect') || '{}')

      return quickselectStorage[this.variationId] ?? []
    },
    isLoading() {
      return this.$store.state.items.isAddToBasketLoading === this.variationId || this.$store.state.items.isSetLoading
    },
  },

  methods: {
    /**
     * add an item to basket-resource
     */
    addToBasket(upssellingVariationId) {
      this.$store.commit('setIsAddToBasketLoading', this.variationId)

      const basketObject = {
        variationId: upssellingVariationId,
        quantity: 1,
        basketItemOrderParams: [],
        totalOrderParamsMarkup: 0,
      }

      this.$store.dispatch('addBasketItem', basketObject).then(
          (response) => {
            document.dispatchEvent(
                new CustomEvent('afterBasketItemAdded', {
                  detail: basketObject,
                }),
            )
            this.$store.commit('setIsAddToBasketLoading', 0)
          },
          (error) => {
            this.$store.commit('setIsAddToBasketLoading', 0)
            if (error.data) {
              window.CeresNotificationService.error(
                  this.$translate('Ceres::Template.' + ExceptionMap.get(error.data.exceptionCode.toString()), error.data.placeholder),
              ).closeAfter(5000)
            }
          },
      )
    },
  },
}
</script>
